import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "costMethodInput",
    "defaultPriceSection",
    "defaultPriceLabel",
    "unitSelect",
    "unitHint",
  ];
  static values = {
    laborDayUnitIds: Array,
    defaultPriceLabels: Object,
  };

  connect() {
    if (this.hasDefaultPriceLabelTarget) {
      this.defaultPriceLabelFallback =
        this.defaultPriceLabelTarget.textContent.trim();
    }
    this.syncLaborDayCostMethod();
    this.toggleDefaultPrice();
    this.refreshUnitHint();
    this.refreshDefaultPriceLabel();
  }

  onUnitChange() {
    this.syncLaborDayCostMethod();
    this.toggleDefaultPrice();
    this.refreshUnitHint();
    this.refreshDefaultPriceLabel();
  }

  toggleDefaultPrice() {
    if (!this.hasDefaultPriceSectionTarget) return;
    const hide = this.#currentMethod() === "labor_unit";
    this.defaultPriceSectionTarget.classList.toggle("hidden", hide);
    if (hide) {
      const input = this.defaultPriceSectionTarget.querySelector("input");
      if (input) input.value = "";
    }
  }

  refreshUnitHint() {
    if (!this.hasUnitHintTarget || !this.hasUnitSelectTarget) return;
    this.unitHintTarget.classList.toggle("hidden", !this.#isLaborDayUnit());
  }

  refreshDefaultPriceLabel() {
    if (!this.hasDefaultPriceLabelTarget || !this.hasUnitSelectTarget) return;
    const selectedId = this.unitSelectTarget.value;
    const label = this.defaultPriceLabelsValue[selectedId];
    this.defaultPriceLabelTarget.textContent =
      label || this.defaultPriceLabelFallback;
  }

  syncLaborDayCostMethod() {
    if (!this.hasCostMethodInputTarget) return;

    const laborDay = this.#isLaborDayUnit();
    const taskUnitOption = this.costMethodInputTarget.querySelector(
      'option[value="task_unit"]',
    );

    if (taskUnitOption) {
      taskUnitOption.disabled = laborDay;
      taskUnitOption.hidden = laborDay;
    }

    if (laborDay && this.#currentMethod() !== "labor_unit") {
      this.costMethodInputTarget.value = "labor_unit";
    }
  }

  #isLaborDayUnit() {
    if (!this.hasUnitSelectTarget) return false;
    const selectedId = this.unitSelectTarget.value;
    return (
      !!selectedId &&
      this.laborDayUnitIdsValue.map(String).includes(selectedId)
    );
  }

  #currentMethod() {
    if (!this.hasCostMethodInputTarget) return "task_unit";
    return this.costMethodInputTarget.value || "task_unit";
  }
}
